__turbopack_context__.v({
  "alignedCombobox": "ContactFormEditorial-module__uKklDG__alignedCombobox",
  "attachmentNotice": "ContactFormEditorial-module__uKklDG__attachmentNotice",
  "checkboxField": "ContactFormEditorial-module__uKklDG__checkboxField",
  "emailSuggestion": "ContactFormEditorial-module__uKklDG__emailSuggestion",
  "expandable": "ContactFormEditorial-module__uKklDG__expandable",
  "fieldWithSuggestion": "ContactFormEditorial-module__uKklDG__fieldWithSuggestion",
  "fields": "ContactFormEditorial-module__uKklDG__fields",
  "fileUploadWrapper": "ContactFormEditorial-module__uKklDG__fileUploadWrapper",
  "form": "ContactFormEditorial-module__uKklDG__form",
  "honeypot": "ContactFormEditorial-module__uKklDG__honeypot",
  "privacy": "ContactFormEditorial-module__uKklDG__privacy",
  "privacyLink": "ContactFormEditorial-module__uKklDG__privacyLink",
  "spin": "ContactFormEditorial-module__uKklDG__spin",
  "spinner": "ContactFormEditorial-module__uKklDG__spinner",
  "submitButton": "ContactFormEditorial-module__uKklDG__submitButton",
});
